/**
 * Hero Slideshow Manager - Moon Moon Agency
 * Diaporama interne aux visuels MM-Hero (2 ou 3 medias par zone).
 *
 * L'enchainement reste automatique ; les points places en bas du visuel
 * indiquent le media affiche et permettent d'y aller directement. Un clic
 * relance le minuteur, pour laisser au visuel choisi sa duree complete.
 *
 * Le fondu lui-meme est en CSS (mm-hero.css) : ce module ne fait que deplacer
 * la classe .is-active. En reduced-motion, pas d'enchainement automatique.
 */

/*********************************************************************************************
 * 🖼️ HERO SLIDESHOW MANAGER
 */
const HeroSlideshowManager = {
	config: {
		selectors: {
			slideshow: '[data-hero-slideshow]',
			media: '.mm-hero__media',
			dot: '[data-hero-slide-dot]',
		},
		classes: {
			active: 'is-active',
		},
		defaultSpeed: 4,
	},

	slideshows: [],
	listening: false,

	init() {
		this._teardown();
		this._bindEvents();

		const zones = window.getElements(this.config.selectors.slideshow);
		if (!zones.length) return; // Guard clause : aucun diaporama sur la page

		const auto = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

		this.slideshows = [...zones].map((zone) => {
			const slideshow = {
				zone,
				medias: [...zone.querySelectorAll(this.config.selectors.media)],
				dots: [...zone.querySelectorAll(this.config.selectors.dot)],
				speed: (Number(zone.dataset.heroSlideSpeed) || this.config.defaultSpeed) * 1000,
				current: 0,
				timer: null,
				auto,
			};
			this._start(slideshow);
			return slideshow;
		});

		window.log('info', '🖼️ [HERO_SLIDESHOW]', `Initialized (${this.slideshows.length})`);
	},

	/**
	 * Un seul listener delegue, pose une fois : init() est rejoue par l'editeur
	 * de theme et ne doit pas empiler les handlers.
	 */
	_bindEvents() {
		if (this.listening) return;
		this.listening = true;

		document.addEventListener('click', (e) => {
			const dot = e.target.closest(this.config.selectors.dot);
			if (!dot) return;
			const slideshow = this.slideshows.find((s) => s.zone.contains(dot));
			if (!slideshow) return;
			this._show(slideshow, Number(dot.dataset.heroSlideDot));
			this._start(slideshow);
		});
	},

	_start(slideshow) {
		clearInterval(slideshow.timer);
		if (!slideshow.auto || slideshow.medias.length < 2) return;
		slideshow.timer = setInterval(() => {
			this._show(slideshow, (slideshow.current + 1) % slideshow.medias.length);
		}, slideshow.speed);
	},

	_show(slideshow, index) {
		if (!slideshow.medias[index]) return;
		slideshow.current = index;

		slideshow.medias.forEach((media, i) => {
			media.classList.toggle(this.config.classes.active, i === index);
		});

		// aria-current expose le visuel affiche sans dupliquer l'info visuelle.
		slideshow.dots.forEach((dot, i) => {
			const active = i === index;
			dot.classList.toggle(this.config.classes.active, active);
			if (active) {
				dot.setAttribute('aria-current', 'true');
			} else {
				dot.removeAttribute('aria-current');
			}
		});
	},

	_teardown() {
		this.slideshows.forEach((slideshow) => clearInterval(slideshow.timer));
		this.slideshows = [];
	},
};

// Auto-init avec vérification readyState
if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', () => HeroSlideshowManager.init());
} else {
	HeroSlideshowManager.init();
}

// Re-init sur rechargement de section depuis l'editeur de theme
document.addEventListener('shopify:section:load', () => HeroSlideshowManager.init());
document.addEventListener('shopify:section:unload', () => HeroSlideshowManager.init());
